import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchPosts, clearPosts, deletePost as deletePostAction, editPost as editPostAction } from '../redux/actions/post';
import PostWidgetRedux from "./PostWidgetRedux";
import AuthenticationPrompt from "../components/Profile/AuthenticationPrompt";

const PostsWidgetRedux = ({ ownerId, profileType, isProfile = true, highlightedPostId = null }) => {
  const dispatch = useDispatch();
  // Using useSelector to get the state from Redux store
  const { posts, fetchPostsLoading, error } = useSelector(state => state.posts);

  useEffect(() => {
    if (isProfile && !ownerId) {
      return;
    }
    // Clear posts only when a concrete profile target is ready.
    dispatch(clearPosts());
    // Dispatch the fetchPosts action on component mount or when ownerId changes
    dispatch(fetchPosts(profileType, ownerId, isProfile));
  }, [dispatch, ownerId, profileType, isProfile]);

  
   useEffect(() => {
    if (posts && posts.length > 0) {
      console.log("Fetched posts:", posts);
    }
  }, [posts]);

  useEffect(() => {
    if (!highlightedPostId || !posts?.length || typeof window === "undefined") {
      return;
    }

    const frameId = window.requestAnimationFrame(() => {
      const targetPost = document.getElementById(`profile-post-${highlightedPostId}`);

      if (targetPost) {
        targetPost.scrollIntoView({ behavior: "smooth", block: "center" });
      }
    });

    return () => window.cancelAnimationFrame(frameId);
  }, [highlightedPostId, posts]);


  // Handle post deletion
  const handlePostDelete = (deletedPostId) => {
    // Dispatch deletePost action
    dispatch(deletePostAction(deletedPostId));
  };

  // Handle post edit
  const handlePostEdit = (updatedPost) => {
    // Dispatch editPost action
    dispatch(editPostAction(updatedPost));
  };

  if (fetchPostsLoading) {
    return (
      <div className="profile-posts-loading" aria-hidden="true">
        {[0, 1].map((index) => (
          <div key={index} className="profile-posts-loading-card">
            <div className="skeleton profile-posts-loading-line profile-posts-loading-line-short" />
            <div className="skeleton profile-posts-loading-line" />
            <div className="skeleton profile-posts-loading-line" />
            <div className="skeleton profile-posts-loading-media" />
          </div>
        ))}
      </div>
    );
  }
  // Handle error state
  if (error) {
    const errorString = String(error);
  
    if (errorString.includes("401")) {
      return <AuthenticationPrompt forceVisible />;
    } else {
      return <div>Error fetching posts: {errorString}</div>;
    }
  }

  if (Array.isArray(posts) && posts.length === 0) {
    return (
      <div className="profile-posts-empty-state" role="status">
        <h4 className="profile-posts-empty-title">No posts yet.</h4>
        <p className="profile-posts-empty-message">
          {profileType === 'Shop'
            ? 'When this shop shares updates, announcements, or featured content, it will appear here.'
            : 'When this profile shares updates, stories, or featured content, it will appear here.'}
        </p>
      </div>
    );
  }
  

  return (
    <>
      {posts && posts.map(post => (
        <div
          key={`${post._id}-${ownerId}`}
          id={`profile-post-${post._id}`}
          className="profile-post-anchor"
        >
          <PostWidgetRedux
            postId={post._id}
            owner={post.owner}
            postUserId={post.postUserId}  
            profileType={post.profileType}
            name={post.name}
            description={post.description}
            location={post.location}
            images={post.images}        
            videos={post.videos}       
            avatar={post.avatar}
            likes={post.likes}
            link={post.link}
            comments={post.comments}
            totalComments={post.totalComments}
            createdAt={post.createdAt}
            updatedAt={post.updatedAt}
            onShareSuccess={() => {}}
            resharedBy={post.resharedBy}
            reshareDescription={post.reshareDescription}
            reshareAvatar={post.reshareAvatar}
            onPostDelete={handlePostDelete}
            onPostEdit={handlePostEdit}
            isLikedByCurrentUser={post.isLikedByCurrentUser}
            isHighlighted={post._id === highlightedPostId}
            isProfilePost={isProfile}
          />
        </div>
      ))}
    </>
  );
};

export default PostsWidgetRedux;


